import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAllTracks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2803 25.88C12.2803 25.2964 12.7534 24.8232 13.337 24.8232H30.8563C31.44 24.8232 31.9131 25.2964 31.9131 25.88C31.9131 26.4636 31.44 26.9367 30.8563 26.9367H13.337C12.7534 26.9367 12.2803 26.4636 12.2803 25.88Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2803 22.2403C12.2803 21.6567 12.7534 21.1836 13.337 21.1836H30.8563C31.44 21.1836 31.9131 21.6567 31.9131 22.2403C31.9131 22.824 31.44 23.2971 30.8563 23.2971H13.337C12.7534 23.2971 12.2803 22.824 12.2803 22.2403Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.08887 22.6836C3.08887 21.8552 3.76044 21.1836 4.58887 21.1836H9.67897C10.5074 21.1836 11.179 21.8552 11.179 22.6836V25.4367C11.179 26.2651 10.5074 26.9367 9.67897 26.9367H4.58887C3.76044 26.9367 3.08887 26.2651 3.08887 25.4367V22.6836Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2803 12.7599C12.2803 12.1762 12.7534 11.7031 13.337 11.7031H30.8563C31.44 11.7031 31.9131 12.1762 31.9131 12.7599C31.9131 13.3435 31.44 13.8166 30.8563 13.8166H13.337C12.7534 13.8166 12.2803 13.3435 12.2803 12.7599Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2803 9.12022C12.2803 8.5366 12.7534 8.06348 13.337 8.06348H30.8563C31.44 8.06348 31.9131 8.5366 31.9131 9.12022C31.9131 9.70385 31.44 10.177 30.8563 10.177H13.337C12.7534 10.177 12.2803 9.70385 12.2803 9.12022Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.08887 9.56348C3.08887 8.73505 3.76044 8.06348 4.58887 8.06348H9.67897C10.5074 8.06348 11.179 8.73505 11.179 9.56348V12.3166C11.179 13.145 10.5074 13.8166 9.67897 13.8166H4.58887C3.76044 13.8166 3.08887 13.145 3.08887 12.3166V9.56348Z",
			fill: "currentColor"
		})
	]
});
export default SvgAllTracks;
